 <template>
  <b-container fluid class="container-layout">
    <!--carrera-->
    <b-row align-h="center">
      <p class="title mt-4">CARRERA: {{carrera | upper}}</p>
    </b-row>
    <!--felicidades-->
    <b-row align-h="center">
      <p :style="aprobado===false ? 'color:red!important':''" class="title mt-4">{{title}}</p>
    </b-row>
    <!--puntaje-->
    <b-row align-h="center">
      <p class="subtitle mt-4">Tu puntaje obtenido es:</p>
    </b-row>
    <b-row align-h="center">
      <p class="title mt-4">
        {{total.puntaje_total}}
        <span class="points">sobre un total de</span>
        {{total.tatal_puntaje}}
        <span class="points">puntos</span>
      </p>
    </b-row>
    <!--nuevo texto titulo-->
    <b-row align-h="center" v-if="aprobado==true">
      <p class="subtitle mt-4">Sin duda tu esfuerzo valió la pena</p>
    </b-row>
    <b-row align-h="center" v-else>
      <p class="subtitle mt-4">Sin duda, estas camino a alcanzar tu meta</p>
    </b-row>
    
    <!--texto nuevo aprobado-->
    <b-row v-if="aprobado==true" align-h="center">
        <b-col cols="10">
            <p class="mt-2 info-result-center-all">
                Estas a un paso de escribir la mejor de tus historias. En la San Pablo estamos listos para ayudarte a alcanzar tus sueños, convertirte en un gran profesional y, sobre todo, en una gran persona. ¿Listo (a) para trascender y cambiar el rumbo de la sociedad?
            </p>
        </b-col>
      <br />
    </b-row>
    <b-row v-if="aprobado==false" align-h="center">
        <b-col cols="10">
            <p class="mt-2 info-result-center-all">
                Te atreviste a dar este primer paso y como resultado has logrado un puntaje considerable. Sabemos que aún puedes dar más de ti, por ello revisa en qué materias estás bien y en qué otras necesitas repasar. Recuerda que los grandes esfuerzos tienen grandes recompensas. ¿Listo (a) para trascender y cambiar el rumbo de la sociedad?
            </p>
        </b-col>
      <br />
    </b-row>

    <b-row align-h="center">
        <b-col cols="10">
            <p class="mt-2 info-result-left-all"> 
                Este es el detalle de tu puntaje:
            </p>
        </b-col>
      <br />
    </b-row>

    <b-row class="mt-2" align-h="center">
      <b-col cols="10">
        <b-table-simple class="table-result" striped hover responsive>
          <b-thead class="thead-table">
            <b-tr>
              <b-th class="table-th-1 text-center" rowspan="2" colspan="2">Modulo</b-th>
              <b-th class="text-center" colspan="4">Preguntas</b-th>
              <b-th class="table-th-2 text-center" rowspan="2" colspan="2">Puntaje</b-th>
            </b-tr>
            <b-tr>
              <b-th class="text-center">Formulas</b-th>
              <b-th class="th-border-1 text-center">Correctas</b-th>
              <b-th class="th-border-2 text-center">Incorrectas</b-th>
              <b-th class="text-center">En blanco</b-th>
            </b-tr>
          </b-thead>
          <b-tbody class="body-result">
            <tr class="puntajes-module" v-for="(item, key) in resultados" :key="key">
              <td class="title-module" colspan="2">{{item.titulo}}</td>
              <td>{{item.formuladas}}</td>
              <td>{{item.correctas}}</td>
              <td>{{item.incorrectas}}</td>
              <td>{{item.enBlanco}}</td>
              <td>{{item.puntaje_total}}</td>
            </tr>
            <tr class="total-module">
              <td class="title-module" colspan="2">Total</td>
              <td>{{total.preguntas_formuladas}}</td>
              <td>{{total.preguntas_correctas}}</td>
              <td>{{total.preguntas_incorrectas}}</td>
              <td>{{total.preguntas_en_blanco}}</td>
              <td>{{total.puntaje_total}}</td>
            </tr>
          </b-tbody>
        </b-table-simple>
      </b-col>
    </b-row>

    <b-row align-h="center" v-if="aprobado==true && resultados.length>0">
      <p class="subtitle mt-4">¡Tenemos una buena noticia para ti!</p>
    </b-row>

    <b-row align-h="center" v-if="aprobado==true && resultados.length>0">
        <b-col cols="10">
            <p class="mt-2 info-result-left-all"> 
              Por tu buen desempeño te hemos otorgado un descuento especial del 50% en el derecho del examen del 26 de octubre, es decir, pagarás solo S/ 295 (Precio regular S/ 590).<br /><br />
              Para hacer efectivo este beneficio solo debes seguir los siguientes pasos:
                <br /><br />
                <ul>
                    <li>
                      Llena tu ficha de pre inscripción en el siguiente link: <a target="_blank" href="https://admision.ucsp.edu.pe/inscripcion">https://admision.ucsp.edu.pe/inscripcion</a> 
                    </li>
                    <li>
                    Sube tus documentos al formulario enviado a tu correo.
                    </li>
                    <li>
                    Un asesor validará tus documentos y se comunicará contigo para hacer efectivo tu beneficio.
                    </li>
                    <li>
                    Tu beneficio será válido hasta el jueves 9 de octubre de 2025.
                    </li>
                </ul>
                * Un asesor educativo se comunicará contigo por si tienes alguna duda o necesitas ayuda en los pasos anteriores. 
                <br>
                Infórmate más sobre el Examen UCSP, ingresa a: https://admision.ucsp.edu.pe/
            </p>
        </b-col>
      <br />
    </b-row>
    <b-row align-h="center" v-if="aprobado==false && resultados.length>0">
      <p class="subtitle mt-4">¡Tenemos una buena noticia para ti!</p>
    </b-row>
    <b-row align-h="center" v-if="aprobado==false && resultados.length>0">
        <b-col cols="10">
            <p class="mt-2 info-result-left-all"> 
              En la San Pablo estamos convencidos de tu potencial y talento, queremos ayudarte a desarrollarlos y alcanzar tus sueños. Como reconocimiento a tu iniciativa y determinación, te hemos otorgado un descuento en el derecho del examen del 26 de octubre, pagarás solo S/ 450 (Precio regular S/ 590). <br /><br />                  
              Para hacer efectivo este beneficio solo debes seguir los siguientes pasos: 
                <br /><br />
                <ul>
                    <li>
                    Llena tu ficha de pre inscripción en el siguiente link: <a target="_blank" href="https://admision.ucsp.edu.pe/inscripcion">https://admision.ucsp.edu.pe/inscripcion</a> 
                    </li>
                    <li>
                    Sube tus documentos al formulario enviado a tu correo.
                    </li>
                    <li>
                    Un asesor validará tus documentos y se comunicará contigo para hacer efectivo tu beneficio.
                    </li>
                    <li>
                    Tu beneficio será válido hasta el jueves 9 de octubre de 2025.
                    </li>
                </ul>
                * Un asesor educativo se comunicará contigo por si tienes alguna duda o necesitas ayuda en los pasos anteriores. 
                <br>
                Infórmate más sobre el Examen UCSP, ingresa a: https://admision.ucsp.edu.pe/
            </p>
        </b-col>
      <br />
    </b-row>
    <!--texto nuevo-->

    <b-row align-h="center">
      <p class="mt-2 info-result">
        Infórmate más sobre el Examen UCSP, ingresa a:
      </p>
      <br />
    </b-row>
    <b-row align-h="center">
      <a target="_blank" href="https://admision.ucsp.edu.pe">https://admision.ucsp.edu.pe/</a>
    </b-row>
    
    <b-row align-h="center" class="mt-5">
      <!--<p @click="imprimir()" class="title-diagram">Descargar Resultados</p>-->
      <b-col cols="12" class="mt-2" style="text-align: center">
        <span @click="imprimir()">
          <img :src="srcImagen('pdf.svg')" class="results-pdf-img" alt />
          <a class="results-dowload">DESCARGAR RESULTADOS</a>
        </span>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>

export default {
  name: "ResultsStudianteId",
  components: {},
  props: {
    puntaje: String,
    total: Object,
    resultados: Array,
    carrera: String,
    aprobado: Boolean
  },
  data: () => ({
    key: localStorage.getItem('idkey')
  }),
  methods: {
    imprimir() {
      window.print();
    },
    goRouter(url) {
      this.$router.push(url);
    },
    srcImagen(img) {
      let src = require("@/assets/images/" + img);
      return src;
    }
  },
  filters: {
    upper: function(value) {
      return value.toUpperCase();
    }
  },
  computed: {
    title() {
      return this.aprobado === true ? "¡Felicitaciones!" : "¡Buen trabajo!";
    },
    afir() {
      return this.aprobado === true ? "" : "NO";
    }
  }
};
</script>
<style scoped>
</style>
